// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    GIFT_GUIDE_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_GUIDE_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.giftGuideDetail,
        year: action.year
      };
    },
    GIFT_GUIDE_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuide.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
